// extracted by mini-css-extract-plugin
export default {"partnerStyles":"Partners_partnerStyles__abBvh","partners":"Partners_partners__0ELVG","overlay":"Partners_overlay__f4O7C"};